var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 11H10.083M18.7913 10.5417V8.875C18.7913 7.77043 17.8959 6.875 16.7913 6.875H1.83301V17.25C1.83301 18.3546 2.72844 19.25 3.83301 19.25H16.7913C17.8959 19.25 18.7913 18.3546 18.7913 17.25V15.5833",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7083 14.125V12C19.7083 11.4477 19.2606 11 18.7083 11H18.5C17.3954 11 16.5 11.8954 16.5 13V13.125C16.5 14.2296 17.3954 15.125 18.5 15.125H18.7083C19.2606 15.125 19.7083 14.6773 19.7083 14.125Z",
    stroke: "#595959",
    strokeWidth: 1.3,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 6.41671V6.41671C1.83301 5.59315 2.35349 4.85954 3.13081 4.58748L8.33897 2.76462C9.63932 2.3095 10.9997 3.27464 10.9997 4.65234V6.41671",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4719acf9895efd9b8f8d6750e2bd3e3a.svg";
export { ForwardRef as ReactComponent };